import { Alert, Stack } from '@mui/material'
import type { CanonicalPeriod, EmissionTier } from '../common'
import FreezeThawOverview from './freezeThaw/FreezeThawOverview'
import FreezeThawTrends from './freezeThaw/FreezeThawTrends'

type PropertyFreezeThawProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
}

export default function PropertyFreezeThaw({ propertyId, emissionTier, selectedPeriod }: PropertyFreezeThawProps) {
  if (!propertyId) {
    return <Alert severity="info">Select a property to view freeze-thaw metrics.</Alert>
  }

  return (
    <Stack spacing={4}>
      <FreezeThawOverview propertyId={propertyId} emissionTier={emissionTier} selectedPeriod={selectedPeriod} />
      <FreezeThawTrends propertyId={propertyId} emissionTier={emissionTier} />
    </Stack>
  )
}
